import React, { Component } from 'react';
import { has,map} from 'lodash';
import Button from '../common/Button';
import { imageBasePath,appBasePath } from '../../constants/staticData';
import { dateToTime } from '../../helpers';

export default class DriverEmergencyDisplayOnMap extends Component {
    constructor(props) {
        super(props);
         this.state = {
            dropDownVisible: true,
            dropDownVisiblewait:true
        };
        this.declinejob=this.declinejob.bind(this);
        this.acceptjob=this.acceptjob.bind(this);
        this.navigateToMap=this.navigateToMap.bind(this);
        this.startJob=this.startJob.bind(this);
        this.cancelWarning=this.cancelWarning.bind(this);
    }

    componentWillMount() {

    }

    componentWillUnmount() {
     this.props.actions.hidePopUP();
    }

    declinejob(){
      this.props.actions.showPopUP();
    }

    cancelWarning(){
      this.props.actions.driverOfflineWarningHide();
    }
    acceptjob(){
      let selectedData = this.props.selectedData.garagejobquotes;
      let acceptData = {
                        "requestId": selectedData.userbookingrequestId,
                        "jobId": selectedData.id
                       }
      this.props.actions.jobRequestStatusChange('driveracceptjob',acceptData,'','',this.props.selectedData.garagejobquotes.userbookingrequest.customerId);
    }
    navigateToMap(){
      //this.props.actions.navigationFlagSet(true);
      this.props.actions.driverOnlineOfflineMode(2,this.props.router);
      let location = this.props.selectedData.garagejobquotes.userbookingrequest;
      window.open('https://www.google.com/maps/dir/?api=1&destination='+location.latitude+','+location.longitude, "_blank");
    }
    startJob(){
     let selectedData = this.props.selectedData.garagejobquotes;
      let startJobData = {
                        "requestId": selectedData.userbookingrequestId,
                        "jobId": selectedData.id,
                        "status": 11
                       }
          let routeData =`${appBasePath}/driver-CompleteJob/`+this.props.driverid;
      this.props.actions.jobRequestStatusChange('driverupdatejobstatus',startJobData,this.props.router,routeData,this.props.selectedData.garagejobquotes.userbookingrequest.customerId);
      //this.props.router.push()
    }

    render() {
     const {authReducer, commonReducer,driveremergencyReducer,selectedData,flowType} = this.props;
     let garagInfo = (this.props.requestDetails ? this.props.requestDetails.garagejobquote : '');
          let customerInformation = ((selectedData != undefined)  ? selectedData.garagejobquotes.userbookingrequest : '');
            return (

        <div className={(flowType == 'businessDriverTrack')?'driver-emergency-display-container  business-adjust':'driver-emergency-display-container'}>
          <div className={(flowType == 'businessDriverTrack')?'col-xs-12 container-fluid demo':'col-xs-12 col-md-6 col-md-offset-3 business-driver-adjust container-fluid demo'}>
           {flowType == 'acceptDecline' && <div>
            <div className="col-xs-10 emergency-display-map-text col-xs-push-1">
              <div className="col-xs-6 emergency-type-data emergency-type-cutomer-name">{customerInformation.username}</div>
              <div className="col-xs-6 text-right emergency-type-data emergency-font-14">{customerInformation.distance.toFixed(2)}KM</div>
              <div className="col-xs-6 emergency-type-data driver-text-grey emergency-kilo">{selectedData.garagejobquotes.garagejobquotesdetail[0].parent.name}</div>
              <div className="col-xs-6 text-right emergency-type-data driver-text-blue emergency-font-14">{customerInformation.customerPhone}</div>
             </div>
             {(selectedData.jobdetailstatusId == 9)&& <div className="col-xs-12 driver-emergency-btn">
              <div className="col-xs-6"><Button btnType="label" btnSize="sm" fontSize={16} label="Decline" btnCallBack={()=>this.declinejob(this)}  customClass="btn-theme-save"/></div>
              <div className="col-xs-6"><Button btnType="label" btnSize="sm" fontSize={16} label="Accept" btnCallBack={()=>this.acceptjob(this)}  customClass="btn-theme-save driver-active-btn"/></div>
             </div>}
             {(selectedData.jobdetailstatusId == 10) && <div className="col-xs-12 driver-emergency-btn">
              <div className="col-xs-6"><Button btnType="label" btnSize="sm" fontSize={16} label="Navigate" btnCallBack={()=>this.navigateToMap(this)}  customClass="btn-theme-save"/></div>
              <div className="col-xs-6"><Button btnType="label" btnSize="sm" fontSize={16} label="Start Job" btnCallBack={()=>this.startJob(this)}  customClass="btn-theme-save driver-active-btn"/></div>
             </div>}
            </div>
            }
            {flowType == 'offlineFlag' && driveremergencyReducer.driverOfflineFlag &&
            driveremergencyReducer.driverAcceptFlag && <div className="warning-message-length">
              <div className="col-xs-2 warning-message-img"><img  src={`${imageBasePath}/warning.png`} alt="Warning" ></img>
              </div>
              <div className="col-xs-10">
                <div className="emergency-type-cutomer-name">Oops!<span className="text-right" onClick={()=> this.cancelWarning()}><img src={`${imageBasePath}/delete.png`} alt="delete"></img></span></div>
                <div className="warning-message-text">Looks like you have jobs in queue .Finish the jobs in Queue to go offline</div>
              </div>

            </div>}
            {flowType == 'businessDriverTrack' && <div className="warning-message-length col-xs-12 display-emegency-container container-fluid">
             <div className="col-xs-2 emergency-type-data"><img src={`${imageBasePath}/pic.png`} alt="driver_pic"/></div>
             <div className="col-xs-4 container-fluid"><div className="emergency-type-data">{garagInfo.emergencyjobdetails[0].driverName}</div><div className="emergency-type-data driver-text-blue">{garagInfo.emergencyjobdetails[0].driverPhone}</div></div>
             <div className="col-xs-6 emergency-type-data emergency-last-update">Last Updated: <span>{dateToTime(new Date(garagInfo.createdAt))} </span></div>
              </div>
              }
          </div>
          
        </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/DriverEmergency/DriverEmergencyDisplayOnMap.jsx